import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="resizeobserversize" id="resizeobserversize"></a>
    <h1 {...{
      "id": "windowresizeobserversize"
    }}>{`window.ResizeObserverSize`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://drafts.csswg.org/resize-observer/#resizeobserversize"
      }}>{`ResizeObserverSize`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="new-resizeobserversize-new" id="new-resizeobserversize-new"></a>
    <h2 {...{
      "id": "resizeobserversizeinlinesize-blocksize"
    }}>{`ResizeObserverSize(inlineSize, blockSize)`}</h2>
    <p>{`Represents the size of an element's observed box.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`inlineSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The size of the element in the inline direction.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`blockSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The size of the element in the block direction.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="resizeobserversize-inlinesize" id="resizeobserversize-inlinesize"></a>
    <h2 {...{
      "id": "inlinesize--number"
    }}>{`inlineSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the size of the element in the inline direction.`}</p>
    <a name="resizeobserversize-blocksize" id="resizeobserversize-blocksize"></a>
    <h2 {...{
      "id": "blocksize--number"
    }}>{`blockSize : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the size of the element in the block direction.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      